import React, { useEffect, useState } from "react";
import styles from "styles/BulkUploadModal.module.css";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import DragAndDropUpload from "components/FileUploader/DragAndDropUpload";
import {
    Grid,
    Grid2,
    useTheme,
    Button,
    Box,
    Modal,
    Typography,
    Link,
    Autocomplete,
    TextField,
    ImageList,
    ImageListItem,
    ImageListItemBar,
} from "@mui/material";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useNavigate, useParams } from "react-router-dom";
import { useAddImageGalleryMutation } from "store/slices/apis/imageGallerySlice";
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"


const ImageGalleryUploader = ({ fileUploadModal, setFileUploadModal, refetch, categories }) => {
    const navigate = useNavigate();
    const { projectId } = useParams();
    const theme = useTheme();
    const dispatch = useDispatch();
    const [selectedFile, setSelectedFile] = useState(null);
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addImage, addImageRes] = useAddImageGalleryMutation();
    const [categrory, setCategory] = useState("");
    const [categroryError, setcategroryError] = useState("");

    const openNotification = async (msg, type = "error") => {
        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: "alert",
                alert: {
                    color: type,
                },
                close: false,
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);
    };

    const handleDrop = (acceptedFiles, rejectedFiles) => {

        const validFiles = [];
        const oversizedFiles = [];

        acceptedFiles.forEach((file) => {
            if (file.size <= 2 * 1024 * 1024) {
                validFiles.push(file);
            } else {
                oversizedFiles.push(file);
            }
        });

        if (oversizedFiles.length > 0) {
            // oversize image validation messasge (Invalid file(s). Each file must be under 2MB and in correct format.)
            openNotification("Invalid format please upload correct format");
            return;
        }

        if (rejectedFiles.length > 0) {
            openNotification("Invalid format please upload correct format");
            return;
        }
        setSelectedFile((prevFiles) => {
            if (!Array.isArray(prevFiles)) {
                prevFiles = [];
            }
            return [...prevFiles, ...acceptedFiles];
        });
        setFiles(prevFiles => [
            ...prevFiles,
            ...acceptedFiles.map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            ),
        ]);

    };

    useEffect(() => {
        return () => files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);

    useEffect(() => {
        if (addImageRes?.isSuccess) {
            if (addImageRes?.data?.status == 'Success') {
                openNotification(addImageRes?.data?.message, 'success')
            } else {
                openNotification(addImageRes?.data?.message, 'success')
            }
            setFileUploadModal(false);
            setSelectedFile(null);
            setFiles([]);
            setcategroryError("");
            setCategory("");
            navigate(`/projects/${projectId}/image-gallery/pending-approval-images`);
        }
    }, [addImageRes?.isSuccess]);

    useEffect(() => {
        if (addImageRes?.isError) {
            openNotification('Something went problem!', 'error')
        }
    }, [addImageRes?.isError]);

    const handleUpload = async () => {
        if (!categrory) {
            setcategroryError("Category field is a mandatory field.");
            return;
        }

        const formData = new FormData();
        formData.append('projectId', projectId)
        formData.append('category', categrory)
        if (selectedFile != null) {
            selectedFile?.map((value, key) => {
                formData.append('files', value)
            })
        }

        addImage(formData);

        // setLoading(true);
        // try {
        //     const response = await fileUpload({
        //         file: selectedFile,
        //         projectId: projectId || null,
        //         type: categrory,
        //     }).unwrap();
        //     openNotification(
        //         response?.message ||
        //         "File uploaded successfully. Processing in background.",
        //         "success"
        //     );
        //     setSelectedFile([]);
        //     setLoading(false);
        //     setFileUploadModal(false);
        //     refetch();
        // } catch (error) {
        //     openNotification("File upload failed. Please try again.", "error");
        //     setLoading(false);
        // }
    };

    const handleModalClose = () => {
        setFileUploadModal(false);
        setSelectedFile(null);
        setFiles([]);
        setcategroryError("");
        setCategory("");
    };

    const handleRemoveElement = (index) => {
        // console.log(selectedFile, files);
        let resultFile = [...files];
        let resultSectedFile = [...selectedFile];

        resultSectedFile.splice(index, 1)
        setSelectedFile(resultSectedFile)

        // Revoke object URL to free memory
        // if (resultFile[index]?.preview) {
        //     URL.revokeObjectURL(resultFile[index].preview);
        // }

        resultFile.splice(index, 1)
        setFiles(resultFile)
    }

    const thumbs = files.map((file, index) => (
        <>
            <ImageListItem key={file.preview}>
                <img
                    // srcSet={`${file.preview}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                    src={`${file.preview}`}
                    alt={file.preview}
                    loading="lazy"
                    onLoad={() => { URL.revokeObjectURL(file.preview) }}
                />
                {/* <ImageListItemBar
                    actionIcon={
                        <IconButton
                            onClick={() => handleRemoveElement(index)}
                            sx={{ color: 'rgba(255, 255, 255,1)', backgroundColor: '#696969', padding: 0 }}
                        // aria-label={`info about ${item.title}`}
                        >
                            <IoMdCloseCircle />
                        </IconButton>
                    }
                /> */}
            </ImageListItem>
        </>
    ));

    return (
        <Modal
            open={fileUploadModal}
            onClose={(e, reason) => {
                if (reason !== "backdropClick") {
                    setFileUploadModal(false);
                }
            }}
            className={styles.modalWrapper}
            sx={{
                "& .css-4nmryk-MuiBackdrop-root-MuiModal-backdrop": {
                    opacity: "0 !important",
                },
                marginTop: "260px !important",
            }}
        >
            <Box className={styles.modalContent} sx={{
                width: {
                    xs: '350px !important',
                    sm: '555px'
                },
            }}>
                <Box className={styles.modalHeader}>
                    <Typography variant="h6" className={styles.modalTitle}>
                        Image Gallery Upload
                    </Typography>
                    <IconButton>
                        {/* <ClearIcon
                            sx={{ fontSize: "25px", opacity: "0.5" }}
                            onClick={() => handleModalClose()}
                        /> */}
                         <CrossIcon
                            style={{  fontSize: "20px", width:"20px", height:"20px", fill:"#808080" }}
                            onClick={() => handleModalClose()}
                        />
                    </IconButton>
                </Box>

                <Box>
                    <Grid2
                        sx={{
                            marginBottom: "20px",
                        }}
                    >
                        <Autocomplete
                            options={categories?.data?.[0]?.items || []}
                            getOptionLabel={(option) => option?.value}
                            onChange={(_, newValue) => {
                                setCategory(newValue ? newValue?.value : "");
                                setcategroryError("");
                            }}
                            sx={{
                                "& .MuiAutocomplete-inputRoot": {
                                    paddingTop: "8px !important",
                                    paddingBottom: "7px !important",
                                    paddingRight: "0px !important",
                                },
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Category"
                                    name="fileType"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        "& .MuiFilledInput-root": {
                                            backgroundColor: "#fff",
                                        },
                                        minWidth: "230px",
                                        marginTop: "12px",
                                    }}
                                />
                            )}
                            ListboxProps={{
                                sx: { fontSize: "13px" },
                            }}
                        />
                        {categroryError && (
                            <Typography
                                sx={{
                                    color: "#C52A1A",
                                    fontSize: "12px",
                                    marginTop: "5px",
                                }}
                            >
                                {categroryError}
                            </Typography>
                        )}
                    </Grid2>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <Typography className={styles.description}>
                        Upload files up to 2 MB only
                    </Typography>
                </Box>
                <Box className={styles.uploadBox}>
                    <DragAndDropUpload onDrop={handleDrop} fileType="image" multi={true} />
                </Box>
                {files?.length > 0 &&
                    <ImageList cols={10}>
                        {thumbs}
                    </ImageList>
                }
                <Box className={styles.buttonContainer}>
                    <Grid2>
                    </Grid2>
                    <Grid2>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: `${theme?.customSettings?.themeColor}`,
                                color: "#FFF !important",
                                fontSize: "16px",
                                lineHeight: "24px",
                                fontWeight: 500,
                                padding: "8px 24px",
                                textTransform: "none",
                                "&.Mui-disabled": {
                                    backgroundColor: `${theme?.customSettings?.themeColor}1F`,
                                    color: "#FFF !important",
                                },
                            }}
                            loading={addImageRes?.isLoading}
                            onClick={handleUpload}
                            disabled={!selectedFile?.length}
                        >
                            Upload
                        </Button>
                    </Grid2>
                </Box>
            </Box>
        </Modal>
    );
};

export default ImageGalleryUploader;
